















import Vue, { PropType } from 'vue';
import { i18n, i18nHints } from '../../plugins/i18n';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-skill-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionSkillItemStoreEdit from '@/store/modules/cvSectionSkillItemEdit';
import { CvSectionSkillItem } from '@/../gen';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    sectionItem: {
      type: Object as PropType<CvSectionSkillItem>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, description, strength }: FormDataInterface) {
      const { cv_section_skill_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionSkillItemStoreEdit.UpdateCvSectionSkillItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_skill_id,
            id,
          },
          body: {
            title,
            description,
            strength,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_section_skill_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionSkillItemStoreEdit.DeleteCvSectionSkillItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_skill_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
